import styled from 'styled-components';

import { media } from 'utils/detection';
import FeaturedTeamMember from 'components/FeaturedTeamMember';

export default styled(FeaturedTeamMember)`
  position: relative;
  display: inline-block;
  margin: 28px 0;

  ${media.medium`
    display: table;
    margin-left: 0;
    left: 50%;
  `}

  &:nth-child(1) {
    margin-top: 48px;
  }

  &:nth-child(odd) {
    margin-left: -40px;

    ${media.medium`
      margin-left: 0;
      transform: translate(-90%, 0);
    `}
  }

  &:nth-child(even) {
    margin-right: -40px;

    ${media.medium`
      margin-right: 0;
      margin-left: -25%;
      margin-top: -100px;
      left: 10vw;
    `}
  }
`;
